/**
 * The platform attribution shown in the sidebar foot when the rail mark and
 * header logo belong to the tenant (white-labelled shell).
 *
 * Sized for the 80px rail: a hairline separator, a tracked "POWERED BY"
 * caption, and the full LognAI wordmark — which at ~54px wide fits on one
 * line, unlike the two-line "Powered by LognAI" text it replaced.
 */

import { Logo, type LogoProps } from './Logo';

interface Props {
  /** Matches the sidebar surface, same as the rail mark it replaces. */
  variant: LogoProps['variant'];
}

export function PoweredByLognAI({ variant }: Props) {
  return (
    <div
      className="flex flex-col items-center gap-1.5 border-t border-sidebar-border pb-1 pt-3"
      aria-label="Powered by LognAI"
    >
      <span className="whitespace-nowrap text-[8px] font-medium uppercase leading-none tracking-[0.08em] text-neutral-500">
        Powered by
      </span>
      <Logo variant={variant} className="h-[18px] w-auto opacity-80" />
    </div>
  );
}
